/* tslint:disable:max-line-length */
import { DeepPartial, Messages } from '@empathybroker/ebx-gluon';

export const es: DeepPartial<Messages> = {
  custom: {
    clearSearchInput: 'borrar',
    facetsHeader: 'Filtros'
  },
  close: { buttonText: '' },
  facets: {
    defaultRange: { fromHTML: 'más de {min}' },
    titles: {
      price_facet: 'Precio',
      sizes_facet: 'Talla',
      color_facet: 'Color'
    },
    toggle: {
      default: {
        openHTML: 'Filtrar {numFound} resultados',
        closeHTML: 'Mostrar {numFound} resultados'
      }
    }
  },
  history: {
    disable: 'on',
    enable: 'off'
  },
  search: {
    inputPlaceholderAlternativesHTML: ['']
  },
  noResults: {
    messageHTML: `<span class="ebx-no-results__message-apologies">No hemos podido encontrar resultados para </span><span class="ebx-no-results__message-query">'{query}'</span><span class="ebx-no-results__message-try-again"> Puede que te interesen los siguientes productos</span>`
  },
  nextQueries: {
    titleHTML: 'Te podría interesar',
    nextQuery: {
      titleHTML: 'Otros usuarios han buscado <span class="ebx-next-query__title-query">{query}</span>'
    }
  },
  partialResult: {
    messageHTML: `<span class="ebx-partials__message-apologies">No hemos podido encontrar resultados para </span><span class="ebx-partials__message-query">'{query}'</span><span class="ebx-partials__message-try-again"> Puede que te interesen los siguientes productos</span>`,
    titleHTML: '<span class="ebx-partial-result__title-num-found">{numFound}</span> resultados para <span class="ebx-partial-result__title-term">{term}</span>'

  },
  sort: {
    titleHTML: 'Ordenar',
    sortTitles: {
      default: 'Relevancia',
      priceAsc: 'Precio ascendente',
      priceDesc: 'Precio descendente',
      alphabeat: 'Alfabeticamente'
    }
  }
};
